module.exports = ".all-wrapper.menu-side\n{\n    background-color: transparent !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/applogin/applogin.component.css
// module id = ./src/app/applogin/applogin.component.css
// module chunks = main